export class ToastError extends Error {
    toastKey: ToastKey;
    constructor(toastKey: ToastKey) {
        super(toastKey);
        this.toastKey = toastKey;
    }
}

export const toastKeys = [
    'loginSuccess',
    'logoutSuccess',
    'logoutSessionExpired',
    'authRequired',
    'loginFailedToken',
    'loginFailedUser',
    'loginFailedUnknown',
    'authRefreshFailedToken',
    'authRefreshFailedUser',
    'tokenInvalidated',
    'insufficientPermissions',
] as const;

export type ToastKey = (typeof toastKeys)[number];

export const toastLists: Record<
    ToastKey,
    { message: string; type: 'success' | 'info' | 'warning' | 'error' }
> = {
    loginSuccess: {
        message: 'Logged in successfully',
        type: 'success',
    },
    logoutSuccess: {
        message: 'You have been logged out',
        type: 'success',
    },
    logoutSessionExpired: {
        message: 'Your session has expired, please log in again',
        type: 'error',
    },
    authRequired: {
        message: 'You must be logged in to access this page',
        type: 'error',
    },
    loginFailedToken: {
        message: 'Failed to get token',
        type: 'error',
    },
    loginFailedUser: {
        message: 'Failed to fetch user data',
        type: 'error',
    },
    loginFailedUnknown: {
        message: 'An unknown error occurred during login',
        type: 'error',
    },
    authRefreshFailedToken: {
        message: 'Failed to refresh token',
        type: 'error',
    },
    authRefreshFailedUser: {
        message: 'Failed to fetch user data',
        type: 'error',
    },
    tokenInvalidated: {
        message: 'Your token has been invalidated, please log in again',
        type: 'error',
    },
    insufficientPermissions: {
        message:
            'You do not have sufficient permissions to perform this action',
        type: 'error',
    },
} as const;
